export type UserAvatarSize = 'xsm' | 'sm' | 'md' | 'lg'

export const USER_AVATAR_SIZES: UserAvatarSize[] = ['xsm', 'sm', 'md', 'lg']

const STARTS_WITH_LETTER = /^\p{L}/u

export function userInitials(name: string): string {
  const words = name
    .split(/[\s-]+/)
    .filter((word) => STARTS_WITH_LETTER.test(word))

  if (words.length === 0) return ''

  const firstWord = words[0]
  if (words.length === 1) {
    return firstWord.slice(0, 2).toUpperCase()
  }

  const lastWord = words[words.length - 1]
  return (firstWord[0] + lastWord[0]).toUpperCase()
}
